import { useTranslation } from "react-i18next";
import { Heading, Text } from "@nbs/ui";

export function EmptyState({ title, body }: { title?: string; body?: string }) {
  const { t } = useTranslation();
  return (
    <div className="nbs-page-state" role="status">
      <Heading level={2}>{title ?? t("pages.emptyTitle")}</Heading>
      <Text tone="muted">{body ?? t("pages.emptyBody")}</Text>
    </div>
  );
}
